<div class="ioteq-drawer-content">
    <ng-content></ng-content>
</div>
